import ForgotPassword from '../components/ForgotPassword';
import PageLayout from '../components/pageLayout';

function ForgotPasswordPage() {
    return (
        <PageLayout children={<ForgotPassword />} />
    );
}

export default ForgotPasswordPage;
